import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import SolarCell from '../../../components/cell/SolarCell.js';
import InverterBox from '../../../components/cell/InverterBox.js';
import InverterBorder from '../../../components/cell/InverterBorder.js';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';
import {
    getLayoutElement
} from '../measurement/LayoutLib.js';

function SubAdminPVLayout(props) {
    const formfileRef = useRef(null)
    const file_imgRef = useRef(null)
    const file_csvRef = useRef(null)
    const formremapRef = useRef(null)

    const [modal_remap_full, setmodal_remap_full] = useState(false)
    const [modal_file, setmodal_file] = useState(false)
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [data_inverter, setData_inverter] = useState([]);
    const [data_border, setData_border] = useState([])
    const [data_remap, setData_remap] = useState([]);
    const [blink_cmd, setBlink_cmd] = useState({ inv_tag: '', inv: 0, pv: 0 })
    const [hide_editer, setHide_editer] = useState(false)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        return () => {
            // setChart_buffer({})
            // setInverter_item({})
            // setData_systemconfig({})
            // setData_inverter([])
            // setString_tag_list([])
        };
    }, []);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            if (props.data_uioption.pv_layout !== null && props.data_uioption.pv_layout !== undefined) {
                if (props.data_uioption.pv_layout.plot !== null && props.data_uioption.pv_layout.plot !== undefined) {
                    setPlot_layout(props.data_uioption.pv_layout.plot)
                }
            }
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.data_inverter !== null) {
            setData_inverter(props.data_inverter)
        }
    }, [props.data_inverter]);

    useEffect(() => {
        // setPlot_layout(getLayoutElement())
        let dplot = []

        dplot.push({
            type: 'border',
            border_type: 'solid',
            border: [{ x: 64, y: 67 },
            { x: 791, y: 67 },
            { x: 791, y: 188 },
            { x: 813, y: 188 },
            { x: 813, y: 278 },
            { x: 790, y: 278 },
            { x: 790, y: 233 },
            { x: 60, y: 233 },
            { x: 60, y: 67 },
            ]
        })

        dplot.push({
            type: 'border',
            border_type: 'solid',
            border: [{ x: 790, y: 278 },
            { x: 790, y: 309 },
            { x: 813, y: 309 },
            { x: 813, y: 396 },
            { x: 60, y: 396 },
            { x: 60, y: 233 },
            ]
        })
        //  setData_border(dplot)
    }, []);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    const [plot_layout, setPlot_layout] = useState([])

    async function api_import_Layout() {
        setmodal_load({ enable: true, message: "Import solar module layout...." })
        await sleep(500)

        const formData = new FormData();
        formData.append('sitecode', props.permitdata.sitecode)
        formData.append('file_img', file_imgRef.current.files[0])
        formData.append('file_csv', file_csvRef.current.files[0])
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/pvstring/importpvlayout", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                rerset_input_file()
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.layout !== undefined) {
                        if (response.data.layout.plot !== null && response.data.layout.plot !== undefined) {
                            setPlot_layout(response.data.layout.plot)
                        }
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                rerset_input_file()
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function get_inverter_data(id) {
        if (data_inverter !== null && data_inverter !== undefined) {
            if (data_inverter.length > 0) {
                return data_inverter[id - 1]
            }
        }
        return null
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    function get_cell_color(plotrows) {
        let plot_color = ['solar-color-bg-grey', 'solar-color-bg-grey', 'solar-color-bg-grey', 'solar-color-bg-grey', 'solar-color-bg-grey']
        if (plotrows === null) {
            return plot_color
        }

        if (plotrows.length > 0) {
            let id = 0
            plotrows.forEach((elem, index) => {
                id += 1
                if (data_inverter !== null && data_inverter !== undefined) {
                    if (data_inverter[elem.inv - 1] !== null && data_inverter[elem.inv - 1] !== undefined) {
                        if (data_inverter[elem.inv - 1].connection_logger !== undefined) {
                            if (data_inverter[elem.inv - 1].connection_logger === true) {
                                if (data_inverter[elem.inv - 1].connection_device === true) {
                                    if (data_inverter[elem.inv - 1].fault_code === 0) {
                                        if (data_inverter[elem.inv - 1].pvstring !== null && data_inverter[elem.inv - 1].pvstring !== undefined) {
                                            if (data_inverter[elem.inv - 1].pvstring[elem.pv - 1] !== undefined) {
                                                if (data_inverter[elem.inv - 1].pvstring[elem.pv - 1].power_string > 0) {
                                                    plot_color[id - 1] = 'solar-color-bg-green'
                                                } else {
                                                    plot_color[id - 1] = 'solar-color-bg-blue'
                                                }
                                            } else {
                                                plot_color[id - 1] = 'solar-color-bg-grey'
                                            }
                                        } else {
                                            plot_color[id - 1] = 'solar-color-bg-grey'
                                        }
                                    } else {
                                        plot_color[id - 1] = 'alarming'
                                    }
                                } else {
                                    plot_color[id - 1] = 'alarming'
                                }
                            } else {
                                plot_color[id - 1] = 'alarming'
                            }
                        } else {
                            plot_color[id - 1] = 'solar-color-bg-grey'
                        }
                    } else {
                        plot_color[id - 1] = 'solar-color-bg-grey'
                    }
                } else {
                    plot_color[id - 1] = 'solar-color-bg-grey'
                }
            });
        }
        return plot_color
    }

    async function api_remap() {
        var formelement = formremapRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        } else {
            const foundDuplicates = findDuplicates(data_remap)
            if (foundDuplicates.length === 0) {
                setmodal_load({ enable: true, message: "PV Remapping....." })
                await sleep(500)

                const new_inv = Number(blink_cmd.inv_tag.replace("INV-", ""))

                const formData = new FormData()
                formData.append('inv_no', new_inv)
                formData.append('remap', JSON.stringify(data_remap))

                axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/pvstring/editmulti", formData, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'multipart/form-data;',
                        "Authorization": "Bearer " + props.permitdata.token
                    },
                })
                    .then((response) => {
                        setmodal_load({ enable: false, message: "" })
                        if (response.data.status === 'OK') {
                            setModal_popup({
                                modaltype: 'modal-success',
                                headers: 'Success',
                                message: "Your pv no has been saved.",
                                enable: true
                            });
                            if (response.data.layout !== undefined) {
                                setPlot_layout(response.data.layout.plot)
                                setData_remap(data_remap.sort((a, b) => a.pv_old - b.pv_old))
                            }
                        } else {
                            setModal_popup({
                                modaltype: 'modal-error',
                                headers: 'Error',
                                message: response.data.message,
                                enable: true
                            })
                        }
                    })
                    .catch((err) => {
                        setmodal_load({ enable: false, message: "" })
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: err.message,
                            enable: true
                        })
                    });
            } else {
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: "Found duplicated at new pv no. " + foundDuplicates[0],
                    enable: true
                })
            }
        }
    }

    async function api_load_remap(inv_no) {
        const new_inv = inv_no.replace("INV-", "")
        setBlink_cmd({
            ...blink_cmd,
            inv_tag: inv_no
        })
        setmodal_load({ enable: true, message: "Load Existing mapping....." })
        await sleep(500)

        const formData = new FormData()
        formData.append('inv_no', new_inv)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/pvstring/loadpvremap", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.remap_list !== undefined) {
                        if (response.data.remap_list !== null) {
                            setData_remap(response.data.remap_list.sort((a, b) => a.pv_old - b.pv_old))
                            setmodal_remap_full(true)
                        }
                    }
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function force_blink(pv_old) {
        const new_inv = Number(blink_cmd.inv_tag.replace("INV-", ""))
        setBlink_cmd({
            ...blink_cmd,
            inv: new_inv,
            pv: pv_old
        })
    }

    function stop_flasing() {
        setBlink_cmd({
            ...blink_cmd,
            inv: 0,
            pv: 0
        })
    }

    const updateItemValue = (pv_old, newValue) => {
        if (newValue !== "") {
            setData_remap(
                data_remap.map((item) =>
                    item.pv_old === pv_old ? { ...item, pv_new: Number(newValue) } : item
                )
            );
        } else {
            setData_remap(
                data_remap.map((item) =>
                    item.pv_old === pv_old ? { ...item, pv_new: "" } : item
                )
            );
        }
    };

    const findDuplicates = (arr) => {
        const seen = new Set();
        const duplicates = new Set();

        for (const item of arr) {
            if (seen.has(item.pv_new)) {
                duplicates.add(item.pv_new);
            } else {
                seen.add(item.pv_new);
            }
        }
        return Array.from(duplicates);
    };

    function rerset_input_file() {
        file_imgRef.current.value = null
        file_csvRef.current.value = null
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-view-week-outline"></i> PV Layout</h4>
                                    <p className="mb-1">Mange your pv layout.</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn bg-blue btn-sm text-white" onClick={() => { setmodal_file(true); }}>Import Layout</button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card card-common">
                                <div className="card-body pb-0 py-1 px-1">
                                    <div className="d-block">
                                        <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-view-week-outline"></i> PV Layout</h5>
                                        <div className='py-0 my-0 mt-0 fw-600'>PV Color Definition</div>
                                        <div className='d-flex gap-3 flex-wrap mt-0 mb-3'>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle solar-color-txt-green'></i>Power Production</p>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-red'></i>Offline, Fault, Shutdown</p>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle solar-color-txt-blue'></i>No Power</p>
                                            <p className='mb-0 mt-0'><i className='mdi mdi-rectangle solar-color-txt-grey'></i>Unknown</p>
                                        </div>
                                    </div>
                                    <hr className="new-section-xs mb-2" />

                                    <div className='panel-layout-wrapper'>
                                        <div className="solor-layout">
                                            <img alt='layout' src={process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/files/reader?key=" + props.data_uioption.layout_key + "&&pathdir=config&&filename=layout_img_" + props.permitdata.sitecode + ".png"} />
                                            {
                                                plot_layout !== undefined ?
                                                    plot_layout?.map((plot, index2) => (
                                                        plot.type === "header" ?
                                                            <div className='solor-location font-sarabun' style={{ left: plot.x, top: plot.y }} key={'header-' + index2}>{plot.name}</div>
                                                            : plot.type === "inverter" ?
                                                                <InverterBox key={index2} plotdata={plot}
                                                                    invdata={get_inverter_data(plot.inv)}
                                                                    onClick={(inv_no) => { api_load_remap(inv_no) }} />
                                                                : plot.type === "cell" ?
                                                                    <SolarCell key={index2} plotdata={plot} cell_color={get_cell_color(plot.row)} blink_cmd={blink_cmd}
                                                                        onClick={(inv_no, pv_tag, pv_display, pv_no, rowkey, inv) => { }}
                                                                    />
                                                                    : plot.type === "border" ?
                                                                        <InverterBorder key={index2} plotdata={plot} />
                                                                        : plot.type === "tag" ?
                                                                            <div className='solar-tag' style={{ top: plot.y + "px", left: plot.x + "px" }} key={index2}>{plot.name}</div>
                                                                            :
                                                                            null
                                                    ))
                                                    :
                                                    null
                                            }
                                            {
                                                data_border?.map((plot, index2) => (
                                                    <InverterBorder plotdata={plot} />
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div>
                    </div>
                </div>
            </div>

            {
                modal_file ?
                    <div className='modal-overlay'>
                        <div className="modal d-block" >
                            <div className="modal-dialog modal-lg modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Layout File Import</h4>
                                        <i className="fe-x modal-close" onClick={() => { setmodal_file(false) }}></i>
                                    </div>
                                    <div className="modal-body">
                                        <form ref={formfileRef} action="" method="POST" encType="multipart/form-data">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="file_img">Layout Background Image File</label>
                                                        <input type="file" className="form-control" ref={file_imgRef} name="file_img" accept=".png" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="file_csv">Layout Element CSV File</label>
                                                        <input type="file" className="form-control" ref={file_csvRef} name="file_csv" accept=".csv" />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-light btn-sm" type="button" onClick={() => { setmodal_file(false); rerset_input_file() }}><i className="fe-x"></i> Cancel</button>
                                        <button className="btn btn-warning btn-sm" onClick={() => { api_import_Layout() }}><i className="fe-save"></i> Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    null
            }

            {
                modal_remap_full ?
                    <div className='modal-overlay'>
                        <div className="modal d-block" >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">{blink_cmd.inv_tag} PV Remap</h4>
                                        <i className="fe-x modal-close" onClick={() => { setmodal_remap_full(false) }}></i>
                                    </div>
                                    <div className="modal-body">
                                        <form ref={formremapRef} action="" method="POST" encType="multipart/form-data">
                                            <div className="row">
                                                <div className='text-danger mb-2'>Click on previous PV No. in this popup to force PV string flashing !</div>
                                                <div>
                                                    <div className="btn btn-info btn-sm mb-4" onClick={() => { stop_flasing() }}>Stop Flashing</div>
                                                    <div className="btn btn-danger btn-sm mb-4 mx-3" onClick={() => { setHide_editer(!hide_editer) }}>Show/Hide PV Editer</div>
                                                </div>
                                                <div className={'d-flex ' + (hide_editer ? "d-none" : "")}>
                                                    <div className='d-block'>
                                                        {
                                                            data_remap.map((remap, index) => (
                                                                index < 10 ?
                                                                    <div className='d-flex' key={remap.item_keys}>
                                                                        <div className="form-group mb-1">
                                                                            <label htmlFor="cod_acc">Previous PV No.</label>
                                                                            <input type="number" className="form-control cursor-pointers" name="pv_old" min={1} max={28} value={remap.pv_old} onClick={() => { force_blink(remap.pv_old) }} required readOnly />
                                                                        </div>
                                                                        <div className="form-group mb-1 mx-3">
                                                                            <label htmlFor="cod_acc">New PV No.</label>
                                                                            <input type="number" className="form-control" name="pv_new" min={1} max={remap.pv_max} value={remap.pv_new} onChange={(e) => { updateItemValue(remap.pv_old, e.target.value) }} required />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                            ))
                                                        }
                                                    </div>
                                                    <div className='d-block'>
                                                        {
                                                            data_remap.map((remap, index) => (
                                                                index >= 10 && index < 20 ?
                                                                    <div className='d-flex' key={remap.item_keys}>
                                                                        <div className="form-group mb-1">
                                                                            <label htmlFor="cod_acc">Previous PV No.</label>
                                                                            <input type="number" className="form-control cursor-pointers" name="pv_old" min={1} max={28} value={remap.pv_old} onClick={() => { force_blink(remap.pv_old) }} required readOnly />
                                                                        </div>
                                                                        <div className="form-group mb-1 mx-3">
                                                                            <label htmlFor="cod_acc">New PV No.</label>
                                                                            <input type="number" className="form-control" name="pv_new" min={1} max={remap.pv_max} value={remap.pv_new} onChange={(e) => updateItemValue(remap.pv_old, e.target.value)} required />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                            ))
                                                        }
                                                    </div>
                                                    <div className='d-block'>
                                                        {
                                                            data_remap.map((remap, index) => (
                                                                index >= 20 && index < 27 ?
                                                                    <div className='d-flex' key={remap.item_keys}>
                                                                        <div className="form-group mb-1">
                                                                            <label htmlFor="cod_acc">Previous PV No.</label>
                                                                            <input type="number" className="form-control cursor-pointers" name="pv_old" min={1} max={28} value={remap.pv_old} onClick={() => { force_blink(remap.pv_old) }} required readOnly />
                                                                        </div>
                                                                        <div className="form-group mb-1 mx-3">
                                                                            <label htmlFor="cod_acc">New PV No.</label>
                                                                            <input type="number" className="form-control" name="pv_new" min={1} max={remap.pv_max} value={remap.pv_new} onChange={(e) => updateItemValue(remap.pv_old, e.target.value)} required />
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    null
                                                            ))
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                    <div className={"modal-footer " + (hide_editer ? "d-none" : "")}>
                                        <button className="btn btn-light btn-sm" type="button" onClick={() => { setmodal_remap_full(false) }}><i className="fe-x"></i> Cancel</button>
                                        <button className="btn btn-warning btn-sm" onClick={() => { api_remap() }}><i className="fe-save"></i> Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    null
            }

            <ScrollToTopButton />
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default SubAdminPVLayout